var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStripe = function SvgStripe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 18,
    viewBox: "0 0 43 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.498 9.34597C42.498 6.32399 41.0381 3.93945 38.2476 3.93945C35.4454 3.93945 33.75 6.32399 33.75 9.32237C33.75 12.8756 35.7516 14.6699 38.6244 14.6699C40.0255 14.6699 41.0852 14.3511 41.8858 13.9026V11.5416C41.0852 11.943 40.1668 12.1909 39.0012 12.1909C37.8591 12.1909 36.8465 11.7895 36.717 10.3966H42.4745C42.4745 10.2431 42.498 9.62929 42.498 9.34597ZM36.6817 8.22453C36.6817 6.89061 37.4941 6.33579 38.2359 6.33579C38.9541 6.33579 39.7194 6.89061 39.7194 8.22453H36.6817Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2073 3.93945C28.0534 3.93945 27.3117 4.48247 26.8996 4.86022L26.7465 4.12833H24.1562V17.8925L27.0997 17.2669L27.1115 13.9262C27.5354 14.2331 28.1594 14.6699 29.1955 14.6699C31.303 14.6699 33.2222 12.97 33.2222 9.22793C33.2104 5.80459 31.2677 3.93945 29.2073 3.93945ZM28.5008 12.0728C27.8062 12.0728 27.3941 11.8249 27.1115 11.518L27.0997 7.13851C27.4059 6.79617 27.8297 6.56008 28.5008 6.56008C29.5723 6.56008 30.314 7.76415 30.314 9.31056C30.314 10.8924 29.584 12.0728 28.5008 12.0728Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1054 3.24277L23.0607 2.60532V0.208984L20.1054 0.83463V3.24277Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0607 4.13993H20.1054V14.469H23.0607V4.13993Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9386 5.01363L16.7502 4.14009H14.207V14.4691H17.1505V7.46899C17.8452 6.56003 19.0226 6.7253 19.3876 6.85515V4.14009C19.0108 3.99843 17.6332 3.73873 16.9386 5.01363Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0526 1.57813L8.17974 2.19197L8.16797 11.6475C8.16797 13.3946 9.47488 14.6813 11.2174 14.6813C12.1829 14.6813 12.8893 14.5042 13.2779 14.2917V11.8954C12.9011 12.0488 11.0408 12.5918 11.0408 10.8448V6.65412H13.2779V4.13973H11.0408L11.0526 1.57813Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09209 7.1383C3.09209 6.67792 3.46885 6.50085 4.09287 6.50085C4.98769 6.50085 6.11799 6.77236 7.01281 7.25635V4.48226C6.03557 4.09271 5.07011 3.93925 4.09287 3.93925C1.70276 3.93925 0.113281 5.19054 0.113281 7.27996C0.113281 10.538 4.58738 10.0186 4.58738 11.4234C4.58738 11.9664 4.11642 12.1435 3.45708 12.1435C2.47984 12.1435 1.23181 11.7421 0.242794 11.1991V14.0086C1.33777 14.4808 2.44452 14.6815 3.45708 14.6815C5.90606 14.6815 7.58973 13.4656 7.58973 11.3526C7.57796 7.83478 3.09209 8.46042 3.09209 7.1383Z",
    fill: "#635BFF"
  })));
};
export default SvgStripe;